<template>
  <v-container id="obligaciones-tab" fluid>
    <v-row>
      <v-col cols="3">
        <v-autocomplete v-model="jugadorSelected" color="gold" :items="jugadores" label="Jugador" return-object item-text="fullName" :readonly="precargado.idJugador !== 0">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.fullName" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-select v-model="solicitudContrato" color="gold" item-color="gold" label="Solicitud/Contrato" :items="solicitudContratoOp" :readonly="mode === 'precargado'">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
      <v-col v-if="solicitudContrato === 'Solicitud extraordinaria'" cols="3">
        <v-select v-model="solicitudExtra" color="gold" item-color="gold" :items="solicitudesExtras" label="Solicitud extraordinaria" return-object item-text="obligacion.descripcion" :readonly="precargado.idSolicitud !== 0">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.obligacion.descripcion" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
      <v-col v-if="solicitudContrato === 'Contrato'" cols="3">
        <v-select v-model="contratoSelected" color="gold" :items="contratosJugador" label="Contrato" return-object item-text="tipo_contrato.descripcion" :readonly="precargado.idContrato !== 0">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="(item.tipo_contrato.descripcion !== 'Sponsors') ? item.tipo_contrato.descripcion : item.tipo_contrato.descripcion + ' ' + item.sponsor.descripcion" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
      <v-col v-if="solicitudContrato === 'Contrato'" cols="3">
        <v-select v-model="obligacionSelected" color="gold" :items="obligaciones" label="Obligaciones" return-object :item-text="nombreObligacion" :readonly="precargado.idObligacion !== 0">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="nombreObligacion(item)" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-card v-if="Object.keys(obligacionSelected).length !== 0" class="v-card--material pa-3">
      <v-card-text class="px-0 pb-0">
        <v-card-title>
          Cuotas
        </v-card-title>
        <v-row style="overflow: auto; max-height:400px;  min-height:100px">
          <v-col v-for="(itemValue, key) in obligacionSelected.detalle_obligacion_representante" :key="key" cols="6" md="3" class="pb-1 pt-1">
            <v-card class="mt-2 mb-2">
              <v-col cols="12" class="pb-0 pt-1">
                <v-row justify="space-between" class="pl-2">
                  <span style="font-size: 1rem"> {{ montoCantidad(itemValue) }} </span>
                  <v-checkbox v-show="CorrespondePagar(itemValue)" v-model="cuotasObligacionesSelect" :disabled="bloquear" hide-details color="info" class="shrink mr-0 mt-0 pa-0" :value="itemValue" @change="calcularMontoSelec(itemValue)" />
                </v-row>
              </v-col>
              <v-col cols="12" class="pt-1">
                <span style="font-size: 1rem"> Vencimiento: {{ itemValue.vencimiento }} </span>
              </v-col>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-if="Object.keys(solicitudExtra).length !== 0" class="mt-2 mb-2">
      <v-card-text class="px-0 pb-0">
        <v-col cols="12" class="pb-0 pt-1">
          <v-row class="pl-2">
            <v-col cols="12">
              <span style="font-size: 1rem"> {{ montoCantidad(solicitudExtra) }} </span>
            </v-col>
            <v-divider inset />
            <v-col cols="12">
              <span style="font-size: 1rem"> Fecha solicitud: {{ (solicitudExtra.fecha) }} </span>
            </v-col>
            <v-divider inset />
            <v-col cols="12">
              <span style="font-size: 1rem"> Descripción: {{ (solicitudExtra.descripcion) }} </span>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>
    </v-card>
    <v-row class="mt-12">
      <v-col align-self="center" cols="2">
        <span>Definir monto personalizado: </span>
      </v-col>
      <v-col cols="2" class="pa-0">
        <v-text-field v-model="totalSeleccionado" color="gold" type="number" step="0.01" :max="deudaTotalObligacion" prefix="$" label="Total a pagar" :disabled="bloquearTotalSeleccionado()" @change="comprobarMonto()" />
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-btn v-if="habilitarRegNMonetario" color="gold" @click="aplicarPagoObligacion('/api/pago_no_monetario')">
          Registrar
        </v-btn>
        <v-btn v-if="habilitarSolNMonetario" color="gold" @click="aplicarPagoObligacion('/api/pago')">
          Registrar
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'ObligacionesTab',
    props: {
      toggleReset: {
        type: Boolean,
        required: true,
        default: false,
      },
      mode: {
        type: String,
        default: '',
        required: false,
      },
      precargado: {
        type: Object,
        default: null,
      },
      bloquear: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        jugadorSelected: {},
        jugadores: [],
        solicitudExtra: {},
        solicitudesExtras: [],
        contratoSelected: {},
        contratosJugador: [],
        obligacionSelected: {},
        obligaciones: [],
        cuotasObligacionesSelect: [],
        solicitudContratoOp: ['Solicitud extraordinaria', 'Contrato'],
        solicitudContrato: '',
        valorMonetario: false,
        totalSeleccionado: 0,
        deudaTotalObligacion: 0,
        habilitarRegNMonetario: false,
        habilitarSolNMonetario: false,
        bloquearMonto: false,
        contTipos: [],
        objetoAPagar: {
          totalAPagar: 0,
          monedaId: 1,
          objetoPago: null,
          monto: 0,
          impuestos: 0,
          percepciones: 0,
          jugador_id: 0,
          caso: 'Solicitud extraordinaria',
        },
      }
    },
    computed: {},
    watch: {
      toggleReset () {
        this.jugadorSelected = {}
        this.solicitudExtra = {}
        this.contratoSelected = {}
        this.obligacionSelected = {}
        this.cuotasObligacionesSelect = []
        this.totalSeleccionado = 0
        this.deudaTotalObligacion = 0
        this.contTipos = []
      },
      solicitudContrato (val) {
        if (this.mode !== 'precargado') {
          if (val === 'Solicitud extraordinaria') {
            this.obligacionSelected = {}
            this.objetoAPagar.caso = 'Solicitud extraordinaria'
          } else {
            this.$emit('mostrarGestor', true)
            this.bloquearMonto = false
            this.solicitudExtra = {}
            this.objetoAPagar.caso = 'Obligacion'
          }
        }
      },
      solicitudExtra (val) {
        if (Object.keys(val).length !== 0) {
          this.valorMonetario = (val.obligacion.valor_monetario_sn === 1)
          if (this.valorMonetario) {
            this.habilitarSolNMonetario = false
            this.$emit('mostrarGestor', true)
            this.deudaTotalObligacion = val.cantidad
            this.totalSeleccionado = val.cantidad
            this.bloquearMonto = true
            this.enviarPadre(val)
          } else {
            this.habilitarSolNMonetario = true
            this.$emit('mostrarGestor', false)
            this.bloquearMonto = false
          }
          this.objetoAPagar.objetoAPagar = {
            id: val.id,
          }
          this.objetoAPagar.objetoPago = val
        } else {
          this.habilitarSolNMonetario = false
          this.$emit('mostrarGestor', true)
        }
      },
      jugadorSelected (val) {
        if (this.mode !== 'precargado') {
          this.contratoSelected = {}
          this.solicitudContrato = ''
          this.getSolicitudes()
          this.getContratosJugador()
          this.objetoAPagar.jugador_id = val.id
        }
      },
      contratoSelected (val) {
        if (this.mode !== 'precargado') {
          this.obligacionSelected = {}
          this.contTipos = []
          this.obligaciones = []
          if (Object.keys(val).length !== 0) {
            this.generarArreglosContratos()
          }
        }
      },
      obligacionSelected (val) {
        if (Object.keys(val).length !== 0) {
          this.valorMonetario = (val.obligacion.valor_monetario_sn === 1)
          if (this.valorMonetario) {
            this.habilitarRegNMonetario = false
            this.$emit('mostrarGestor', true)
          } else {
            this.habilitarRegNMonetario = true
            this.$emit('mostrarGestor', false)
          }
        } else if (this.precargado.idSolicitud === 0) {
          this.habilitarRegNMonetario = false
          this.$emit('mostrarGestor', true)
        }
        this.reiniciarDerecho(val)
      },
    },
    created () {
      if (this.mode === 'precargado') {
        this.generarFormPrecargado()
      } else {
        this.getJugadores()
      }
    },
    methods: {
      generarFormPrecargado () {
        this.getJugador()
        this.objetoAPagar.jugador_id = this.precargado.idJugador
        if (this.precargado.idContrato !== 0) {
          this.solicitudContrato = 'Contrato'
          this.objetoAPagar.caso = 'Obligacion'
          this.getContratoJugador()
        } else if (this.precargado.idSolicitud !== 0) {
          this.solicitudContrato = 'Solicitud extraordinaria'
          this.objetoAPagar.caso = 'Solicitud extraordinaria'
          this.getSolicitud()
        }
      },
      bloquearTotalSeleccionado () {
        if (this.mode === 'precargado') {
          return (this.valorMonetario)
        }
        return (this.bloquear || this.bloquearMonto)
      },
      aplicarPagoObligacion: async function (url) {
        if (this.cuotasObligacionesSelect.length === 0 && this.solicitudExtra.length === 0) {
          this.$store.commit('toast/show', { tipo: 'info', messages: ['Debe seleccionar al menos una cuota'] })
        } else if (this.totalSeleccionado < 0) {
          this.totalSeleccionado = this.totalSeleccionado * -1
          this.$store.commit('toast/show', { tipo: 'info', messages: ['El monto debe ser positivo'] })
        } else {
          await this.$http({
            method: 'post',
            url: url,
            data: {
              ...this.objetoAPagar,
            },
          }).then(response => {
            this.$store.commit('toast/show', { tipo: 'success', messages: ['Pago registrado'] })
            // this.$router.push({ name: 'Facturas proveedores' })
            this.$router.push({ name: 'Pagos lista' })
          }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        }
      },
      generarArreglosContratos: function () {
        this.obligaciones = this.contratoSelected.obligacion_representante
        this.generarLabelObligaciones(this.obligaciones)
        if (this.mode === 'precargado' && this.precargado.idObligacion !== 0) {
          const cuotasFromContrato = this.$store.getters['dep/getCuotas']
          const index = this.obligaciones.findIndex(e => e.id === this.precargado.idObligacion)
          this.obligacionSelected = this.obligaciones[index]
          this.valorMonetario = (this.obligaciones[index].obligacion.valor_monetario_sn === 1)
          if (cuotasFromContrato.length !== 0) {
            cuotasFromContrato.forEach(e => {
              const aux = this.obligacionSelected.detalle_obligacion_representante.find(j => j.id === e)
              this.cuotasObligacionesSelect.push(aux)
              this.calcularMontoSelec(aux)
            })
          }
        }
      },
      reiniciarDerecho (val) {
        if (Object.keys(val).length !== 0) {
          if (this.valorMonetario) {
            this.deudaTotalObligacion = this.sumarCuotas(val)
          }
        }
        if (this.precargado.idObligacion === 0 && this.precargado.idSolicitud === 0) {
          this.cuotasObligacionesSelect = []
          this.totalSeleccionado = 0
          this.enviarPadre()
        }
      },
      enviarPadre (objetoAPagar = this.cuotasObligacionesSelect) {
        this.objetoAPagar.totalAPagar = this.totalSeleccionado
        this.objetoAPagar.objetoPago = objetoAPagar
        this.$emit('nuevosTotales', this.objetoAPagar)
      },
      sumarCuotas (obligacion) {
        let total = 0
        obligacion.detalle_obligacion_representante.forEach(e => { total += e.cantidad })
        return total
      },
      calcularMontoSelec (item) {
        if (this.valorMonetario) {
          if (this.cuotasObligacionesSelect.includes(item)) {
            const aux = parseFloat(this.totalSeleccionado) + item.cantidad
            this.totalSeleccionado = parseFloat(aux.toFixed(2))
          } else {
            const aux = parseFloat(this.totalSeleccionado) - item.cantidad
            this.totalSeleccionado = parseFloat(aux.toFixed(2))
          }
        } else {
          if (Object.keys(this.cuotasObligacionesSelect).length === 0) {
            this.totalSeleccionado = 0
          }
        }
        this.enviarPadre()
      },
      comprobarMonto () {
        if (Object.keys(this.obligacionSelected).length !== 0 || Object.keys(this.solicitudExtra).length !== 0) {
          this.totalSeleccionado = parseFloat(this.totalSeleccionado)
          if (this.valorMonetario) {
            if (this.totalSeleccionado > this.deudaTotalObligacion) {
              this.totalSeleccionado = this.deudaTotalObligacion
              this.$store.commit('toast/show', { tipo: 'info', messages: ['El monto elegido supera la deuda total de la obligacion seleccionada'] })
            }
            if (this.totalSeleccionado !== 0) {
              this.seleccionarCuotasAutom(this.totalSeleccionado)
            }
          } else {
            if (Object.keys(this.cuotasObligacionesSelect).length === 0 && Object.keys(this.solicitudExtra).length === 0) {
              this.$store.commit('toast/show', { tipo: 'info', messages: ['Debe seleccionar al menos una cuota.'] })
              this.totalSeleccionado = 0
            }
          }
          this.enviarPadre()
        } else {
          this.$store.commit('toast/show', { tipo: 'info', messages: ['Debe seleccionar una obligación.'] })
          this.totalSeleccionado = 0
        }
      },
      seleccionarCuotasAutom (monto) {
        this.cuotasObligacionesSelect = []
        let termino = false
        let i = 0
        let restante = monto
        const maxCuotas = this.obligacionSelected.detalle_obligacion_representante.length
        const arrayAux = []
        while (!termino) {
          if (i < maxCuotas) {
            const montoARestar = this.obligacionSelected.detalle_obligacion_representante[i].cantidad
            if (this.CorrespondePagar(this.obligacionSelected.detalle_obligacion_representante[i])) {
              if ((restante - montoARestar) === 0) {
                restante = 0
                arrayAux.splice(i, 0, this.obligacionSelected.detalle_obligacion_representante[i])
                termino = true
              } else if ((restante - montoARestar) > 0) {
                restante -= montoARestar
                arrayAux.splice(i, 0, this.obligacionSelected.detalle_obligacion_representante[i])
              }
            }
          }
          i += 1
          termino = (i === maxCuotas)
        }
        if (restante !== 0) {
          this.totalSeleccionado -= restante
          this.$store.commit('toast/show', { tipo: 'info', messages: ['El monto elegido fue reajustado.'] })
        }
        this.cuotasObligacionesSelect = arrayAux
      },
      montoCantidad (cuota) {
        return ((this.valorMonetario) ? 'Monto: ' : 'Cantidad: ') + cuota.cantidad
      },
      CorrespondePagar (cuota) {
        if (cuota.valor_monetario !== 0 || cuota.condonada_sn === 1 || cuota.pagos_id !== null) {
          return false
        }
        return true
      },
      nombreObligacion: item => ((item.obligacion) ? item.label : ''),
      generarLabelObligaciones (obligaciones) {
        const cantObligaciones = obligaciones.length
        for (let i = 0; i < cantObligaciones; i++) {
          const index = this.contTipos.findIndex(e => e.tipo === obligaciones[i].obligacion.descripcion)
          if (index !== -1) {
            this.contTipos[index].cont += 1
            if (this.contTipos[index].cont === 2) {
              obligaciones[i].label = obligaciones[i].obligacion.descripcion + ' (2)'
              obligaciones[this.contTipos[index].indexPrimero].label = obligaciones[i].obligacion.descripcion + ' (1)'
            } else if (this.contTipos[index].cont > 2) {
              obligaciones[i].label = obligaciones[i].obligacion.descripcion + ' (' + this.contTipos[index].cont + ')'
            }
          } else {
            const nCont = {
              tipo: obligaciones[i].obligacion.descripcion,
              cont: 1,
              indexPrimero: i,
            }
            obligaciones[i].label = obligaciones[i].obligacion.descripcion
            this.contTipos.push(nCont)
          }
        }
      },
      getJugadores () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },
      getJugador () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador/' + this.precargado.idJugador }).then(response => {
          this.jugadorSelected = response
          this.jugadores.push(response)
        })
      },
      getSolicitud () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/solicitud_jugador_extra/' + this.precargado.idSolicitud }).then(response => {
          this.solicitudExtra = response
          this.solicitudesExtras.push(response)
        })
      },
      getSolicitudes () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/solicitudes_jugador_extra/' + this.jugadorSelected.id }).then(response => {
          this.solicitudesExtras = response
        })
      },
      getContratosJugador: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contratos_jugador_obligaciones/' + this.jugadorSelected.id }).then(response => {
          this.contratosJugador = response
        })
      },
      getContratoJugador () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contrato_jugador_obligaciones/' + this.precargado.idJugador + '/' + this.precargado.idContrato }).then(response => {
          this.contratosJugador.push(response)
          this.contratoSelected = response
          this.generarArreglosContratos()
        })
      },
    },
  }
</script>
